import React, { useState, useEffect } from "react";

const text = `Tristan Oshier is a software engineer and multidisciplinary
                  artist working across clothing, painting, and digital systems,
                  based in New York City and Los Angeles.`;

const Landing = () => {
  const [displayedText, setDisplayedText] = useState("");
  const [index, setIndex] = useState(0);
  const [typingDone, setTypingDone] = useState(false);

  useEffect(() => {
    if (index < text.length) {
      const timeout = setTimeout(
        () => {
          setDisplayedText(text.slice(0, index + 1));
          setIndex(index + 1);
        },
        25 + Math.random() * 40,
      ); // natural typing variation
      return () => clearTimeout(timeout);
    } else if (!typingDone) {
      const pause = setTimeout(() => setTypingDone(true), 500); // pause before cursor disappears
      return () => clearTimeout(pause);
    }
  }, [index, typingDone]);

  return (
    <section className="landing-section">
      <div className="landing-container">
        <p className="landing-description">
          {displayedText}
          {!typingDone && <span className="cursor" />}
        </p>
        {typingDone && (
          <a
            href="mailto:tristan.oshier2000@gmail.com"
            className="contact-link"
          >
            Contact
          </a>
        )}
      </div>
    </section>
  );
};

export default React.memo(Landing);
